import { render, staticRenderFns } from "./sendPage_detail.vue?vue&type=template&id=69e4ed02&scoped=true"
import script from "./sendPage_detail.vue?vue&type=script&lang=js"
export * from "./sendPage_detail.vue?vue&type=script&lang=js"
import style0 from "./sendPage_detail.vue?vue&type=style&index=0&id=69e4ed02&prod&lang=css"
import style1 from "./sendPage_detail.vue?vue&type=style&index=1&id=69e4ed02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e4ed02",
  null
  
)

export default component.exports